export default __webpack_public_path__ + "static/media/generic-desktop.d9ee99f9.png";